var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import "./../FileUploadingCard.css";
import classNames from "classnames";
import { Tag } from "../../../components/Tags";
import { Typography } from "../../../technical-fundamental";
var FileUploadingCardFile = forwardRef(function (_a, ref) {
    var fileName = _a.fileName, type = _a.type, size = _a.size, className = _a.className, style = _a.style, otherProps = __rest(_a, ["fileName", "type", "size", "className", "style"]);
    return (React.createElement("div", __assign({}, otherProps, { ref: ref, className: classNames(className !== null && className !== void 0 ? className : "", "ssg-file-upload-card__file-informations"), style: style }),
        React.createElement(Typography, { className: "ssg-file-upload-card__file-name", variant: "text", size: "sm", noMarginBottom: true }, fileName),
        React.createElement(Typography, { variant: "text", size: "xs", noMarginBottom: true },
            React.createElement(Tag, { as: "span", label: type, className: "fr-text--xs fr-mr-1w", taille: "sm" }),
            size)));
});
export default FileUploadingCardFile;
